export enum ClientDirectoryRoutes {
  Overview = 'overview',
  Administrators = 'administrators',
  Notifications = 'notifications',
  AddNewClient = 'add-new-client',

  DynamicClientId = ':clientId',
}
